const queryString = (params) =>
  Object.keys(params)
    .map((key) => {
      if (Array.isArray(params[key])) {
        return params[key].map((p) => `${key}=${p}`).join('&');
      }
      return `${key}=${params[key]}`;
    })
    .join('&');

export default {
  queryString,
};
